import React from 'react';
import { useLang } from '../context/LanguageContext';

export default function Ticker() {
  const { t } = useLang();
  const items = t('ticker');
  const doubled = [...items, ...items];
  return (
    <div className="relative border-y border-slate-800 bg-[#0B1220] overflow-hidden" data-testid="market-ticker">
      <div className="ticker-track flex whitespace-nowrap py-3 w-max">
        {doubled.map((item, i) => {
          const positive = !item.includes('-');
          return (
            <span key={i} className="text-xs sm:text-sm font-medium mx-6 flex items-center gap-2">
              <span className={`inline-block w-1.5 h-1.5 rounded-full ${positive ? 'bg-green-400' : 'bg-rose-500'}`} />
              <span className={positive ? 'text-green-400' : 'text-rose-400'}>{item}</span>
            </span>
          );
        })}
      </div>
      <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0B1220] to-transparent pointer-events-none" />
      <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#0B1220] to-transparent pointer-events-none" />
    </div>
  );
}
